import { useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import { GetEmailVerification } from "../../redux/auth-reducer/auth-service";
import { GetToken, setStoredEmailVerified } from "../../utils/helper/helper";
import { VERIFY_EMAIL_BUTTON, bannerMessage } from "../../utils/helper/emailVerification";
import { useEmailVerified, useSendVerificationEmail } from "../../hooks/useEmailVerification";

/**
 * Asks a signed-in account whose email is not verified to verify it. Rendered by TopNavbar, so it is
 * on every dashboard page; it goes away once the email is verified.
 *
 * Only accounts that existed before email verification, and Sub-Admins a Manager creates, see it: a
 * new sign-up cannot sign in until it has verified. A Player's sentence says they get no Manager
 * emails until then; a Manager's or Sub-Admin's only asks. The Web Admin gets none.
 *
 * The flag comes from the sign-in response ("isUser"). While it is not true, each page asks
 * Account/GetEmailVerification again, which is how a link confirmed on another device is noticed;
 * once it is true, nothing is asked. "Verify email" emails a new link.
 *
 * @returns {JSX.Element|null}
 */
const EmailVerificationBanner = () => {
  const message = bannerMessage(localStorage.getItem("role"));
  const verified = useEmailVerified();
  const { send, sending } = useSendVerificationEmail();

  // Asked once per page; a refusal or no reply leaves the stored flag as it is.
  useEffect(() => {
    if (!message || verified === true || !GetToken()) return undefined;
    let current = true;
    GetEmailVerification().then((res) => {
      if (current && res?.data?.status === true) setStoredEmailVerified(Boolean(res.data.emailVerified));
    });
    return () => {
      current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  if (!message || verified !== false || !GetToken()) return null;

  return (
    <Alert variant="warning" className="email-verification-banner" role="status">
      <span>{message}</span>
      <Button size="sm" onClick={send} disabled={sending}>
        {VERIFY_EMAIL_BUTTON}
      </Button>
    </Alert>
  );
};

export default EmailVerificationBanner;
